import {
  Columns3,
  Users,
  Ticket,
  CircleCheck,
  Tags,
  Wrench,
  LayoutPanelLeft,
} from 'lucide-react';
import { IconAsset, IconFileAnalytics } from '@tabler/icons-react';

function normalizeBoardName(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

const BOARD_ICON_RULES = [
  { match: (n) => n === 'board', Icon: Columns3, tabler: false },
  { match: (n) => n === 'equipe', Icon: Users, tabler: false },
  { match: (n) => n.includes('abertura de os'), Icon: Ticket, tabler: false },
  { match: (n) => n.includes('fechamento de os'), Icon: CircleCheck, tabler: false },
  { match: (n) => n === 'oficina', Icon: IconAsset, tabler: true },
  { match: (n) => n.includes('outros assuntos'), Icon: Tags, tabler: false },
  { match: (n) => n.includes('consultas e relatorios'), Icon: IconFileAnalytics, tabler: true },
  { match: (n) => n.includes('paineis') || n.includes('dashboard'), Icon: LayoutPanelLeft, tabler: false },
  { match: (n) => n.includes('gestao de tecnicos'), Icon: Wrench, tabler: false },
];

export function getHubBoardIcon(boardName) {
  const normalized = normalizeBoardName(boardName);
  const rule = BOARD_ICON_RULES.find((r) => r.match(normalized));
  return rule || { Icon: Tags, tabler: false };
}

export function sortHubBoards(boards) {
  return [...(boards || [])].sort((a, b) => {
    const countA = Math.max(0, Number(a?.postCount) || 0);
    const countB = Math.max(0, Number(b?.postCount) || 0);
    const aRanked = countA > 0;
    const bRanked = countB > 0;

    if (aRanked && bRanked) {
      if (countB !== countA) return countB - countA;
      return String(a?.name || '').localeCompare(String(b?.name || ''), 'pt-BR');
    }
    if (aRanked !== bRanked) return aRanked ? -1 : 1;
    return String(a?.name || '').localeCompare(String(b?.name || ''), 'pt-BR');
  });
}

export function HubBoardIcon({ boardName, className }) {
  const { Icon, tabler } = getHubBoardIcon(boardName);
  if (tabler) {
    return <Icon size={16} stroke={1.75} className={className} aria-hidden />;
  }
  return <Icon size={16} strokeWidth={1.75} className={className} aria-hidden />;
}
